import { PUBLIC_PAGE_API_ENDPOINT } from "../constants"
import { getAntiforgeryToken } from "../utils/antiforgery"

export interface ResultHash {
	[key: string]: string | string[] | ResultHash
}

export interface SmsProResponseData {
	result: string
	errors: [Record<string, string>]
}

export const sendSmsProMsg = async (body: ResultHash): Promise<Response> => {
	var antiforgeryToken = await getAntiforgeryToken()

	const headers = {
		Accept: "application/json",
		"Content-Type": "application/json; charset=utf-8",
		RequestVerificationToken: antiforgeryToken,
	}

	const options: RequestInit = {
		headers: headers,
		mode: "cors",
		credentials: "include",
		method: "POST",
		body: JSON.stringify(body),
	}

	return await fetch(`${PUBLIC_PAGE_API_ENDPOINT}/api/v1/smspro/send`, options)
}
